module.exports = __webpack_public_path__ + "img/logo-vistat-modern.31cfa82.svg";